import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  signal,
  ViewChild,
} from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { auditTime } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { EventLoggerService } from '@services/event-logger-service';
import { ConnectionService } from '@services/connection-service';
import { BroadcastService } from '@services/broadcast-service';
import { WindowRefService} from '@services/window-ref-service';
import { PlanName, RegimenService, VariantId } from '@services/regimen-service';
import { REGIMEN_VIEW_STATES } from '../regimen.constants';
import { AppWebBridgeService } from '@services/app-web-bridge-service';
import { UnpaidPendingCallService } from '@services/pending-call-banner-service';
import { DeepLinkService } from '@services/deep-link-service';
import { PendingCallBannerState } from '@services/pending-call-banner-service/types';
import { TimeService } from '@services/time-service';
import { AppConfig } from '../../../../app.config';
import { ExperimentService } from '@services/experiment/experiment.service';
import { TimeSlot } from '@shared/bottom-sheet-layouts/pending-call-bottomsheet/request-call-bottomsheet/request-call-bottomsheet.component';
import { ApiClientConstant } from '@cureskin/api-client';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { UserAllocatedDoctorService } from '@services/user-allocated-doctor-service/user-allocated-doctor.service';
import {
  DoctorInfoBottomSheetComponent,
  DoctorInfoBottomSheetData,
  DoctorInfoBottomSheetSource
} from '@shared/bottom-sheet-layouts/doctor-info-bottomsheet/doctor-info-bottomsheet.component';
import { MoneyBackGuaranteePageView } from '../../../../app.constants';
import { UserService} from '@services/user';
import { Experiment } from '@cureskin/api-client/src/server-api';
import { ConsultationSessionService } from '@services/consultation-session-service';

type LinearGradient = {
  color1: string;
  color2: string;
};
@Component({
  selector: 'user-view-regimen-unpaid',
  templateUrl: './user-view-regimen-unpaid.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})

export class UserViewRegimenUnpaidComponent implements AfterViewInit, OnDestroy, OnInit {
  showOptForDoctorCall: boolean;
  @ViewChild('serviceDetail', { static: false }) serviceDetailCard: ElementRef;
  @ViewChild('regimenContainer', { static: false }) regimenContainer: ElementRef;
  @ViewChild('swiper', { static: false }) swiper: ElementRef;
  @Input('fromPreparation') isRedirectFromPreparation: boolean = false;
  @Output('updateRegimen') updateRegimenInfo: EventEmitter<any> = new EventEmitter<any>();
  user: any;
  popUp: any = { open: false };
  callConfirmed: boolean = false;
  isCallSuccessful: boolean = false;
  isCallUnsuccessful: boolean = false;
  userLanguage: string = 'en';
  showRefundPolicyOption: boolean = false;
  newRegimenIconsExperiment: boolean = false;
  hours: number = 1;
  slot: TimeSlot = 'working';
  enableStaticBackground: boolean = false;
  @Input('regimen')
  set regimenObject(regimen: any) {
    if (!regimen) return;
    this.setRegimen(regimen);
  }
  @Input('experiments') experiments: any[];
  @Input('unpaidUserDoctorCalls') unpaidUserDoctorCalls: any[];
  @Output('showSummaryView') showSummaryView: EventEmitter<any> = new EventEmitter();
  @Output('buyNow') buyNow: EventEmitter<any> = new EventEmitter();
  @Output('cartChange') cartChange: EventEmitter<any> = new EventEmitter();
  @Output() doctorCallCreated: EventEmitter<void> = new EventEmitter<void>();
  // show loading icon when fetching new regimen in 2499 experiment.
  @Output() parentLoading: EventEmitter<any> = new EventEmitter<boolean>();
  @Output() selectedPlanEmit: EventEmitter<any> = new EventEmitter<string>();
  regimen: any;
  patientName: string;
  allocatedDoctor: any;
  products: any[];
  productIds: string[];
  productString: string = '';
  isPaidUser: boolean = false;
  // 2499 feat variables
  upsellPlans: Array<string> = ['introductory', 'advance', 'pro', 'assist'];
  upsellPlanWithoutIntroductory: Array<string> = ['advance', 'pro', 'assist'];
  upsellStandAlonePlans: Array<string> = ['introductory', 'advance'];
  selectedPlan: string = this.upsellPlanWithoutIntroductory[0];
  is2499Upsell: boolean = false;
  newRegimenPricingExperiment: any;
  @Input('isRebrandingV1') isRebrandingV1: boolean = false;
  @Input('isRegimenNewPropositionUI') isRegimenNewPropositionUI: boolean = false;
  @Input() scrollContainer?: HTMLElement;
  backgroundColor: string = 'tw-bg-teal-100';
  regimenTagGradientColors: LinearGradient = {
    color1: '#A2DBD0',
    color2: '#14796D',
  };
  doesAllTagsContainRebrandedImages: boolean = false;
  regimenRehaulV3Experiment: { product_order: 'normal' | 'inverse'} | null = null;
  pendingCallBannerExperiment: boolean = false;
  pendingCallBannerExperimentVariantData: any;
  pendingCallState: string | null;
  osInfo: string;
  hidePendingCallBanner: boolean = false;
  unpaidUserChatBotExperiment: boolean = false;
  moneyBackGuaranteeExperiment: any;
  showMoneyBackGuaranteeBanner: boolean = false;
  regimenRehaulV1Experiment: boolean = false;
  removeVariants: boolean = false;
  pendingCallBannerState: PendingCallBannerState = {
    isEligible: false,
    status: null,
    hideBanner: false,
    variantData: null,
    checkComplete: false
  };
  @Input('isKeyboardVisible') set keyboardVisible(value: boolean) {
    if (this._isKeyboardVisible !== value) {
      this._isKeyboardVisible = value;
      this.changeDetector.markForCheck();
    }
  }
  get isKeyboardVisible(): boolean {
    return this._isKeyboardVisible;
  }
  private _isKeyboardVisible = false;
  private subscription: any;
  public bannerCheckComplete = false;
  protected readonly ApiClientConstant = ApiClientConstant;
  acqRebranding2025: boolean = false;
  regimenUpdateTrigger = signal<any>(null);
  defaultDoctorImageThumbnail: string = '';
  instructionVisibilityImprovementExperiment: Experiment;
  singleCtaProducts: boolean;
  isAcqCopyChangesExpActive: boolean = false
  choosePlanHidden: boolean = false;
  private scrollCollapseEnabled: boolean = false;
  private hideAfterTopScroll: boolean = false;
  private scrollSubscription: Subscription | null = null;
  private prevScrollTop: number = 0;
  private static readonly TOP_SCROLL_THRESHOLD_PX = 20;
  private static readonly DIRECTIONAL_SCROLL_DELTA_PX = 5;
  constructor(
    private readonly eventLogger: EventLoggerService,
    public appConfig: AppConfig,
    public conn: ConnectionService,
    private router: Router,
    private broadcast: BroadcastService,
    public unpaidPendingCallService: UnpaidPendingCallService,
    private readonly deepLinkService: DeepLinkService,
    public changeDetector: ChangeDetectorRef,
    private windowRef: WindowRefService,
    private appWebBridge: AppWebBridgeService,
    public timeService: TimeService,
    private readonly route: ActivatedRoute,
    private readonly regimenService: RegimenService,
    private readonly userService: UserService,
    private readonly zone: NgZone,
    private readonly experimentService: ExperimentService,
    private readonly userAllocatedDoctorService: UserAllocatedDoctorService,
    private readonly consultationSessionService: ConsultationSessionService,
    private readonly bottomSheet: MatBottomSheet,
  ) {
    this.defaultDoctorImageThumbnail = this.userAllocatedDoctorService.DEFAULT_DOCTOR_IMAGE_THUMBNAIL;
  }

  async ngOnInit(): Promise<void> {
    const scrollExp = this.experimentService.regimenVariantsScrollViewCollapseExperiment;
    if (scrollExp) {
      this.scrollCollapseEnabled = true;
      this.hideAfterTopScroll = scrollExp.hideAfterTopScroll;
    }
    this.user = await this.conn.getActingUser();
    this.conn.fetchDefaultAddress(this.user).catch((): void => undefined);
    this.patientName = this.getUserFirstName(this.user);
    this.userLanguage = this.user?.get('languagePreference') || this.appConfig.Shared.Languages.EN;
    this.updateBackgroundColor();
    this.trackRegimenViewUnpaidEvents();
    await this.setAllocatedDoctorAndLogIfNotFound();
    this.isPaidUser = this.checkIsPaidUser();
    if (this.regimen?.class) {
      this.consultationSessionService.deleteConsultationDetailsForClass(this.regimen.class);
    }
    this.changeDetector.detectChanges();
    (<Window> this.windowRef.nativeWindow).performance.mark('regimen-page-end');
    const measure: any = (<Window> this.windowRef.nativeWindow).performance
      .measure('regimen_page_loading_time', 'regimen-page-start', 'regimen-page-end');
    this.eventLogger.trackEvent('regimen_page_loading_time', {
      duration: measure.duration,
    });
    this.doesAllTagsContainRebrandedImages = this.regimen?.regimenTag.every((tag: any): boolean => !!tag.rebrandedImageV2);
    this.updateRegimenTagsBorderColor();

    this.subscription = this.broadcast.on<boolean>('KEYBOARD_VISIBLE').subscribe(isVisible => {
      this.zone.run(() => {
        if (this._isKeyboardVisible !== isVisible) {
          this._isKeyboardVisible = isVisible;
          this.changeDetector.markForCheck();
        }
      });
    });
  }

  ngAfterViewInit(): void {
    if (!this.scrollCollapseEnabled) return;
    const container = this.scrollContainer;
    if (!container) return;
    this.prevScrollTop = container.scrollTop;
    this.zone.runOutsideAngular(() => {
      this.scrollSubscription = fromEvent(container, 'scroll', { passive: true })
        .pipe(auditTime(16))
        .subscribe(() => this.handleScrollTick(container.scrollTop));
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
      this.scrollSubscription = null;
    }
  }

  private handleScrollTick(scrollTop: number): void {
    const nextHidden = this.hideAfterTopScroll
      ? this.shouldHideForThresholdMode(scrollTop)
      : this.shouldHideForDirectionalMode(scrollTop);
    this.prevScrollTop = scrollTop;
    this.applyChoosePlanHidden(nextHidden);
  }

  private shouldHideForThresholdMode(scrollTop: number): boolean {
    return scrollTop > UserViewRegimenUnpaidComponent.TOP_SCROLL_THRESHOLD_PX;
  }

  private shouldHideForDirectionalMode(scrollTop: number): boolean {
    if (scrollTop <= 0) return false;
    const diff = scrollTop - this.prevScrollTop;
    const delta = UserViewRegimenUnpaidComponent.DIRECTIONAL_SCROLL_DELTA_PX;
    if (diff > delta) return true;
    if (diff < -delta) return false;
    return this.choosePlanHidden;
  }

  private applyChoosePlanHidden(nextHidden: boolean): void {
    if (nextHidden === this.choosePlanHidden) return;
    this.zone.run(() => {
      this.choosePlanHidden = nextHidden;
      this.changeDetector.markForCheck();
    });
  }

  get choosePlanClasses(): string {
    const base = 'tw-fixed tw-left-0 tw-right-0 tw-z-10 tw-transition-transform tw-duration-300 tw-ease-out tw-will-change-transform';
    const bottom = this.regimen?.orderPlaced ? 'tw-bottom-[74px]' : 'tw-bottom-[94px]';
    const translate = this.choosePlanHidden ? 'tw-translate-y-[70%]' : 'tw-translate-y-0';
    return `${base} ${bottom} ${translate}`;
  }

  get startAgainMarginBottomPx(): number | null {
    const shouldApply = (!this.regimenRehaulV1Experiment || !this.removeVariants) && this.is2499Upsell;
    if (!shouldApply) return null;
    return this.choosePlanHidden ? 34 : 170;
  }

  getFromColor(): string {
    return this.regimenTagGradientColors.color1;
  }

  getToColor(): string {
    return this.regimenTagGradientColors.color2;
  }

  get regimenForInstructionsPage(): void {
    return this.experimentService.regimenRouteExperiment ? this.regimen : null
  }

  async ngOnChanges(): Promise<void> {
    this.user = await this.conn.getActingUser();
    this.osInfo = await this.appWebBridge?.requestOSInformation();
    await this.setUserExperiments();
    this.isAcqCopyChangesExpActive = this.experimentService.acqCopyExperiment;
    const regimenVariantImages = this.regimenService.getRegimenVariantImages(this.regimen.class);
    if (!regimenVariantImages?.variant_1999 || !regimenVariantImages?.variant_1499) {
      await this.regimenService.setRegimenVariantImages(this.regimen, true);
    }
    this.checkForMoneyBackGuaranteeBanner();

    // Check for variant query param to auto-select variant (e.g., from money-back guarantee banner)
    this.handleQueryParamPlanSelection();

    this.changeDetector.detectChanges();
    await this.determineDoctorCallDeepLink();
  }

  async setUserExperiments(): Promise<void> {
    this.experiments.forEach(async (each: any): Promise<void> => {
      if (each.key === 'privacy_policy') {
        this.showRefundPolicyOption = true;
      }
      if (each.key === 'add_extra_regimen_products') {
        this.newRegimenPricingExperiment = each;
      }
      if (each.key === 'regimen_new_icons') {
        this.newRegimenIconsExperiment = true;
      }
      if (each.key === 'regimen_rehaul_v3') {
        this.regimenRehaulV3Experiment = each?.variant;
      }
      if (each.key === 'unpaid_user_pending_call_banner') {
        this.checkForPendingCallBanner(each.variant);
      }
      if (each.key === 'unpaid_user_llm_bot') {
        this.checkForLlmChatBot(each.variant);
      }
      if (each.key === 'regimen_rehaul_v1') {
        this.processRegimenRehaulV1Experiment(each);
      }
      if (each.key === 'acq_rebranding_2025') {
        this.acqRebranding2025 = true;
      }
      if (each.key === 'money_back_guarantee') {
        this.moneyBackGuaranteeExperiment = each;
      }
      if (each.key === 'instruction_visibility_improvement') {
        this.instructionVisibilityImprovementExperiment = each;
        this.singleCtaProducts = each.variant.regimen_page_big_cta ?? false;
      }
    });
  }

  async updateRegimenSelectedVariant(): Promise<void> {
    const selectedVariant = this.regimen.variantId;
    if (!selectedVariant ||
        selectedVariant === this.appConfig.Shared.Regimen.VariantId.variant_1999 ||
        selectedVariant === this.appConfig.Shared.Regimen.VariantId.variant_1499)
      return;
    await this.changeRegimenKitInfo('advance');
  }

  processRegimenRehaulV1Experiment(exp: { variant: any; }): void {
    if (!exp) return;
    const result = this.experimentService.processRegimenRehaulV1Experiment(exp);
    this.regimenRehaulV1Experiment = true;
    this.removeVariants = result.removeVariants ?? false;
  }

  async checkForPendingCallBanner(variant: any): Promise<void> {
    this.pendingCallBannerExperimentVariantData = variant;

    this.pendingCallBannerState = await this.unpaidPendingCallService.calculateBannerState(
      variant,
      this.user,
      this.regimen.class,
      this.unpaidUserDoctorCalls,
      this.regimen?.isPreparationTimePending || false
    );

    this.pendingCallBannerExperiment = this.pendingCallBannerState?.isEligible;
    this.pendingCallState = this.pendingCallBannerState?.status;
    this.hidePendingCallBanner = this.pendingCallBannerState?.hideBanner;
    this.bannerCheckComplete = true;

    this.changeDetector.markForCheck();
  }

  async onPendingCallCreated(): Promise<void> {
    this.doctorCallCreated.emit();
    this.hidePendingCallBanner = false;
    this.changeDetector.markForCheck();
    await this.checkForPendingCallBanner(this.pendingCallBannerExperimentVariantData);
  }

  checkForLlmChatBot(variant: any): void {
    if (!variant) return;

    const isLanguageSupported: boolean = variant.languages.includes(this.userLanguage);
    const showInRegimenPage: boolean = variant.pagesToShow.includes(this.appConfig.Shared.TABS.REGIMEN);
    this.unpaidUserChatBotExperiment = isLanguageSupported && showInRegimenPage;
  }

  checkForMoneyBackGuaranteeBanner(): void {
    if (!this.moneyBackGuaranteeExperiment || !this.regimen) {
      this.showMoneyBackGuaranteeBanner = false;
      return;
    }

    if (this.userService.isPaidUser(this.user)) {
      this.showMoneyBackGuaranteeBanner = false;
      return;
    }

    const currentVariantId = this.regimenService.getSelectedVariantIdFromRegimen(this.regimen);
    if (!currentVariantId) {
      this.showMoneyBackGuaranteeBanner = false;
      return;
    }

    const regimenClass = this.regimen.class;
    const variantArray = this.moneyBackGuaranteeExperiment?.variant?.[regimenClass] || [];
    this.showMoneyBackGuaranteeBanner = variantArray.includes(currentVariantId);
  }

  updateBackgroundColor(): void {
    const variantId = this.regimenService.getSelectedVariantIdFromRegimen(this.regimen);
    this.backgroundColor = this.regimenService.getBackgroungColourBasedOnVariantId(variantId);
  }

  // Set the allocated doctor property if available and log an event if not found
  private async setAllocatedDoctorAndLogIfNotFound(): Promise<void> {
    if (this.user.get('allocatedDoctor')) {
      this.allocatedDoctor = await this.conn.findUserByObjectId(this.user.get('allocatedDoctor')?.id);
    } else {
      this.eventLogger.trackEvent('DOCTOR_NOT_FOUND_IN_REGIMEN_UNPAID_VIEW', {
        username: this.user.get('username'),
        regimenId: this.regimen.regimenId,
      });
    }
    this.changeDetector.detectChanges();
  }

  async changeRegimenKitInfo(plan: string): Promise<void> {
    this.selectedPlan = plan;
    let indexOfVariant = 0;
    switch (this.regimen?.variants.length) {
      case 2:
        indexOfVariant = this.upsellStandAlonePlans.indexOf(this.selectedPlan);
        break;
      case 3:
        indexOfVariant = this.upsellPlanWithoutIntroductory.indexOf(this.selectedPlan);
        break;
      case 4:
        indexOfVariant = this.upsellPlans.indexOf(this.selectedPlan);
        break;
      default:
        break;
    }
    const selectedVariant = this.regimen.variants[indexOfVariant];
    const selectedVariantId = selectedVariant?.variantId;
    if (this.regimen.variantId === selectedVariantId) {
      return;
    }
    this.copyVariantData(selectedVariant, indexOfVariant);
    this.regimen.variantId = selectedVariantId;
    this.regimen.selectedVariantId = selectedVariantId;
    this.regimenService.setRegimenVariantId(selectedVariantId);
    this.updateBackgroundColor();
    this.updateRegimenTagsBorderColor();
    await this.setRegimenAndEmitUpdate(this.regimen, this.regimen.variantId);
    if (this.regimen?.variantId) {
      await this.conn.updateRegimenInfo(this.regimen.regimenId, this.regimen.variantId);
      if (this.regimen?.extraProducts?.length) {
        const extraProductIds: string[] = this.regimen?.extraProducts?.map((product: any): string => product?.objectId) || [];
        await this.conn.updateRegimenPrice({ regimenId: this.regimen.regimenId, extraProductIds });
      }
    }
    const productsCount = selectedVariant?.products?.length;
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'treament_plan_changed', variantId: selectedVariant?.variantId, productsCount }), [
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.MOENGAGE,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ]);
    await this.handleMandatoryVariantCall(indexOfVariant);
    this.changeDetector.detectChanges();
  }

  copyVariantData(selectedVariant: any, indexOfVariant: number): void {
    Object.keys(this.regimen?.variants[indexOfVariant]).forEach((key: any): void => {
      this.regimen[key] = selectedVariant[key];
    });
  }

  /**
   * Handles variant query parameter to auto-select plan (e.g., from money-back guarantee banner)
   * Converts variant ID to plan name and updates the regimen
   */
  handleQueryParamPlanSelection(): void {
    const variantParam = this.route.snapshot.queryParams['variant'];
    if (!variantParam || !this.regimen?.variants?.length) {
      return;
    }

    const planName = this.getPlanNameByVariantId(variantParam as VariantId);
    if (!planName) {
      return;
    }

    setTimeout(async () => {
      await this.changeRegimenKitInfo(planName);
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { variant: null },
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
    }, 100);
  }

  async setRegimenAndEmitUpdate(regimen: any, variantId: string): Promise<void> {
    // Create a new object reference to trigger change detection in child components (choose-plan)
    const updatedRegimen = { ...regimen };
    await this.setRegimen(updatedRegimen);
    this.regimenService.updateRegimenInStore(this.regimen);
    // Informs the parent component to update the price in Buy Now CTA
    this.updateRegimenInfo.emit(this.regimen);
  }

  /*
    Note: This block is for 2999 mandatory call. Please remove this once backend solution is implemented.
    If the user has opted for doctor call, no change needed
  */
  async handleMandatoryVariantCall(indexOfVariant: number): Promise<void> {
    const hasIntroductoryKit = this.regimen?.variants.length === 4;
    const isMandatoryVariantCallWithIntroKit = hasIntroductoryKit && indexOfVariant === 3;
    const isMandatoryVariantCallWithoutIntroKit = !hasIntroductoryKit && indexOfVariant === 2;
    const mandatoryVariantCall = isMandatoryVariantCallWithIntroKit || isMandatoryVariantCallWithoutIntroKit;
    if (!this.regimen?.optedForDoctorCall) {
      await this.conn.optForRegimenDoctorCall(this.regimen.regimenId, mandatoryVariantCall);
      this.regimen.optedForDoctorCall = mandatoryVariantCall;
      if (mandatoryVariantCall) {
        this.user.set('hasUserOptedForCall', false);
        await this.user.save();
      }
    } else {
      const hasUserOptedForCall = this.user?.get('hasUserOptedForCall') || false;
      const is999Variant = this.regimen?.variantId === 'variant_999';
      if ((!hasUserOptedForCall && !mandatoryVariantCall) || is999Variant) {
        await this.conn.optForRegimenDoctorCall(this.regimen.regimenId, false);
        this.regimen.optedForDoctorCall = false;
      }
    }
  }

  getPlanNameByVariantId(variantId: VariantId): PlanName | undefined {
    return this.regimenService.getPlanNameByVariantId(variantId);
  }

  private getEnabledPlansForMoneyBackGuarantee(): PlanName[] {
    if (!this.regimen?.class) {
      return [];
    }
    return this.regimenService.getEnabledPlansForMoneyBackGuarantee(this.moneyBackGuaranteeExperiment, this.regimen.class, this.user);
  }

  readMoreAboutPlans(): void {
    if (this.conn.isInternalUser() || this.regimen?.orderPlaced) {
      return;
    }

    const selectedPlan = this.regimen?.selectedVariantId ? this.getPlanNameByVariantId(this.regimen?.selectedVariantId) : this.selectedPlan;
    const params = {
      class: this.regimen.class,
      plan: selectedPlan,
      isStandAlone: this.regimen.variants.length === 2,
      isRegimenNewPropositionUI: this.isRegimenNewPropositionUI,
      regimenId: this.regimen?.regimenId,
      doctorImageUrl: this.allocatedDoctor?.get('DoctorImageThumbnail'),
      optedForDoctorCall: this.regimen?.optedForDoctorCall,
    };
    this.router.navigate(['/user/regimen/plan-info'],
      { queryParams: params });
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'read-more-plan' }));
  }

  async buyRegimen(): Promise<void> {
    this.buyNow.emit();
  }

  async startAgain(): Promise<any> {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ pageName: 'unpaid-reanswer-tree' }));
    await this.conn.disablePreviousConsultationSessions(this.regimen.class);
    return this.conn.navigateToURL(`/mainConcern?force=true&class=${this.regimen.class}`);
  }

  async getUniqueProducts(regimen: any): Promise<{ productIds: string[], products: any[] }> {
    const uniqueProducts: { [key: string]: any } = {};

    if (regimen.morning && regimen.night) {
      [...regimen.morning, ...regimen.night].forEach((item: any): void => {
        uniqueProducts[item.product.objectId] = item;
      });
    }
    return {
      productIds: Object.keys(uniqueProducts),
      products: Object.values(uniqueProducts),
    };
  }

  async getProductString(products: any[]): Promise<string> {
    const productLabels: string[] = products.map((item: any): string => {
      if (item.purpose && item.purpose !== 'na') return item.purpose;
      if (item.product.hiddenTitle) return item.product.hiddenTitle;
      return item.product.title;
    });

    return productLabels.join(' + ');
  }

  async setRegimen(regimen: any): Promise<void> {
    this.regimen = regimen;
    this.regimenService.setRegimenVariantId(this.regimen.variantId);
    this.is2499Upsell = this.regimen?.variants && this.regimen?.variants.length;

    // Initialize selectedPlan from regimen's variantId if available
    if (this.is2499Upsell && this.regimen?.variantId) {
      const planFromVariant = this.getPlanNameByVariantId(this.regimen.variantId);
      if (planFromVariant) {
        this.selectedPlan = planFromVariant as string;
      }
    }

    this.updateBackgroundColor();
    this.updateRegimenTagsBorderColor();

    const { productIds, products }: { productIds: string[]; products: any[] } = await this.getUniqueProducts(regimen);
    this.productIds = productIds;
    this.products = products;
    this.productString = await this.getProductString(products);
    // query the mediaLink for coverImage
    if (this.is2499Upsell) {
      const { combinedProductIds }: any = this.regimen;
      const mediaLinkObj = await this.conn.fetchImageFromMediaLink(combinedProductIds);
      this.regimen.regimenCoverImage = mediaLinkObj[0]?.get('link');
    }
    const updatedRegimen = { ...this.regimen };
    this.regimenUpdateTrigger.set(updatedRegimen);
    this.checkForMoneyBackGuaranteeBanner();
    this.changeDetector.detectChanges();

  }

  getUserFirstName(user: any): string {
    const name = user?.get('PatientName') || '';
    return name
      .split(' ')
      .map((word: string): string => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())[0];
  }

  trackEventAndLogCleverTap(event: string, eventName: string): void {
    this.eventLogger.trackEvent(event, { username: this.user.get('username') });
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: eventName }));
    this.eventLogger.trackInFirebaseAndBranch(event);
  }

  /** Navigates to the new instructions route when the regimen_instruction route variant is enabled. */
  private navigateToNewInstructionsRouteIfEnabled(): boolean {
    if (!this.experimentService.regimenRouteVariant?.[REGIMEN_VIEW_STATES.INSTRUCTION]) return false;
    this.router.navigate(['/regimen/instructions'], {
      queryParams: { class: this.regimen.class, regimenId: this.regimen.regimenId },
    });
    return true;
  }

  seeInstructions(): void {
    this.trackEventAndLogCleverTap('REGIMEN_VIEW_SEE_INSTRUCTION', 'regimen-see-instructions');
    if (this.navigateToNewInstructionsRouteIfEnabled()) return;
    this.showSummaryView.emit(true);
  }

  navigateAndTrackEvent(event: string, route: string): void {
    this.eventLogger.trackEvent(event, { username: this.user.get('username') });
    this.eventLogger.trackInFirebaseAndBranch(event);
    this.router.navigate([`/user/regimen/${route}`], {
      queryParams: {
        class: this.regimen.class,
        username: this.user.get('username'),
        regimenId: this.regimen.regimenId,
      },
    });
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: `read-more-${route}` }));
  }

  readMoreAboutDoctor(): void {
    if (!this.allocatedDoctor) return;
    this.trackDoctorBannerEvents();
    this.bottomSheet.open(DoctorInfoBottomSheetComponent, {
      data: {
        doctor: this.allocatedDoctor,
        source: DoctorInfoBottomSheetSource.REGIMEN,
        orderPlaced: this.regimen.orderPlaced,
        buyNowCallback: () => this.buyNow.emit(),
      } as DoctorInfoBottomSheetData,
    });
  }

  trackDoctorBannerEvents(): void {
    this.eventLogger.trackEvent('REGIMEN_VIEW_READ_ABOUT_DOCTOR', { username: this.user.get('username') });
    this.eventLogger.trackInFirebaseAndBranch('REGIMEN_VIEW_READ_ABOUT_DOCTOR');
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'read-more-doctor' }));
  }

  readMoreAboutServices(): void {
    if (this.is2499Upsell) {
      this.readMoreAboutPlans();
      return;
    }
    this.navigateAndTrackEvent('REGIMEN_VIEW_READ_ABOUT_SERVICES', 'services');
  }

  readMoreAboutProducts(): void {
    this.navigateAndTrackEvent('REGIMEN_VIEW_READ_ABOUT_PRODUCTS', 'products');
  }

  clickOnRegimenImage(): void {
    this.trackEventAndLogCleverTap('REGIMEN_VIEW_REGIMEN_IMAGE_CLICK', 'regimen-cover-image');
    if (this.singleCtaProducts) {
      this.clickOnProductImage();
      return;
    }
    if (this.navigateToNewInstructionsRouteIfEnabled()) return;
    this.showSummaryView.emit();
  }

  clickOnProductImage(): void {
    this.trackEventAndLogCleverTap('REGIMEN_VIEW_PRODUCT_IMAGE_CLICK', 'regimen-product-image');
    if (this.navigateToNewInstructionsRouteIfEnabled()) return;
    this.showSummaryView.emit();
  }

  // Track various events for analytics purposes
  private trackRegimenViewUnpaidEvents(): void {
    this.eventLogger.trackEvent('REGIMEN_VIEW_UNPAID', { username: this.user.get('username'), regimenId: this.regimen.regimenId });
    this.eventLogger.trackInFirebaseAndBranch('REGIMEN_VIEW_UNPAID');
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'regimen-view-unpaid',
      regimenClass: this.regimen.class,
      regimenId: this.regimen.regimenId,
      regimenConcern: this.regimen.concern,
      skinType: this.regimen.skinType }));
    this.appWebBridge.logEventInBranchAndFirebaseFromiOS({
      branch: { name: 'REGIMEN_VIEW_UNPAID' },
      firebase: { name: 'REGIMEN_VIEW_UNPAID' },
    });
  }

  protected checkIsPaidUser(): boolean {
    return [
      this.appConfig.Shared.User.OrderState.DELIVERED,
    ].includes(this.user.get('orderState'));
  }

  back(): void {
    this.broadcast.broadcast('NAVIGATION_BACK');
  }

  regimenOfferProductEvent(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'free_travel_pouch_clicked_regimenpage' }));
  }

  updateRegimenTagsBorderColor(): void {
    this.regimenTagGradientColors = this.regimenService.getRegimenTagBorderColorBasedOnBgColor(this.backgroundColor);
  }

  async determineDoctorCallDeepLink(): Promise<void> {
    if (!this.deepLinkService.shouldProcessPendingCallDeepLink()) return;

    const bannerReady = await this.waitForBannerStateReady();
    if (!bannerReady) {
      return;
    }

    if (!this.pendingCallBannerState.isEligible ||
        this.pendingCallBannerState.hideBanner ||
        this.pendingCallBannerState.status) {
      return;
    }

    const hhmm = this.timeService.getMilitaryTime();
    const slot = this.unpaidPendingCallService.determineSlot(hhmm);

    const result = await this.deepLinkService.processPendingCallDeepLink({
      regimen: this.regimen,
      variantData: this.pendingCallBannerExperimentVariantData,
      slot,
      bannerState: this.pendingCallBannerState
    });

    if (result.success) {
      await this.onPendingCallCreated();
    }
  }

  /**
   * Waits for banner state to be ready by checking both the flag and the state object
   */
  private async waitForBannerStateReady(maxAttempts: number = 50): Promise<boolean> {
    let attempts = 0;
    while (attempts < maxAttempts) {
      // Check if banner check is complete AND we have variant data
      if (this.bannerCheckComplete &&
          this.pendingCallBannerExperimentVariantData &&
          this.pendingCallBannerState.checkComplete !== undefined) {
        return true;
      }
      await new Promise(resolve => setTimeout(resolve, 100));
      attempts++;
    }
    return false;
  }

  get shouldShowPendingCallBannerContainer(): boolean {
    return this.pendingCallBannerState.isEligible;
  }

  get shouldShowChatBanner(): boolean {
    return this.unpaidUserChatBotExperiment && this.userService.hasNotPlacedOrder(this.user) && this.isLanguageSupportedForChat;
  }

  get doctorCallBannerContainerClasses(): string {
    return this.pendingCallBannerExperimentVariantData.newBannerUI ?
      'tw-mb-5 tw-px-5'
      : 'tw-mt-4 tw-bg-white tw-pt-6';
  }

  get chatBannerContainerClasses(): string {
    if (!this.shouldShowPendingCallBannerContainer) {
      return 'tw-my-4 tw-bg-white tw-pb-4 tw-px-4';
    }
    return 'tw-px-4 tw-bg-white tw-mb-4';
  }

  get isLanguageSupportedForChat(): boolean {
    const userLang = this.user?.get('languagePreference');
    return [
      this.appConfig.Shared.Languages.EN,
      this.appConfig.Shared.Languages.HI
    ].includes(userLang);
  }

  get videoCallExperiment(): boolean {
    return this.experimentService.videoCallExperiment;
  }

  protected readonly MoneyBackGuaranteePageView = MoneyBackGuaranteePageView;
}
